import mixpanelLib from 'mixpanel-browser';

const singletonEnforcer = Symbol();

class MixPanel {
  static mixpanelInstance;

  constructor(enforcer) {
    if (enforcer !== singletonEnforcer) {
      throw new Error('Cannot initialize Axios client single instance');
    }
    const IS_DEVELOPMENT = process.env.REACT_APP_BACKEND_URL_APP_MODE !== 'PRODUCTION';
    const token = IS_DEVELOPMENT ?
      process.env.REACT_APP_MIXPANEL_DEVELOPMENT_TOKEN:
      process.env.REACT_APP_MIXPANEL_PRODUCTION_TOKEN;

    mixpanelLib.init(token, { debug: IS_DEVELOPMENT })
  }

  /** @return { MixPanel } **/
  static get instance() {
    if (!this.mixpanelInstance) {
      this.mixpanelInstance = new MixPanel(singletonEnforcer);
    }

    return this.mixpanelInstance;
  }

  track(eventName, properties) {
    return mixpanelLib.track(eventName, properties);
  }

  identify(distinctId) {
    return mixpanelLib.identify(distinctId);
  }

  reset(distinctId) {
    return mixpanelLib.reset(distinctId);
  }

  flush(distinctId) {
    return mixpanelLib.flush(distinctId);
  }
}

export const mixpanel = MixPanel.instance;
